<script lang="ts">
export interface SplitterProps extends SplitterGroupProps, ClassProps {}
</script>

<script setup lang="ts">
import {
	SplitterGroup,
	SplitterResizeHandle,
	useForwardPropsEmits,
	type SplitterGroupEmits,
	type SplitterGroupProps,
} from "reka-ui";
import { h, useSlots, type VNode } from "vue";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn, tw } from "../../lib/utils";
import { normalizeVNode } from "../../lib/vnode";

const props = defineProps<SplitterProps>();
const emit = defineEmits<SplitterGroupEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);

const slots = useSlots();

function makeResizeHandle() {
	let classes: string;
	if (props.direction === "horizontal") {
		classes = tw`w-2`;
	} else {
		classes = tw`h-2`;
	}

	return h(SplitterResizeHandle, {
		class: classes,
	});
}

function SlotRenderer() {
	const slot = normalizeVNode(slots.default?.());
	if (slot == null) {
		return null;
	}

	const nodes: VNode[] = [slot.splice(0, 1)[0]];

	for (const node of slot) {
		nodes.push(makeResizeHandle(), node);
	}

	return nodes;
}
</script>

<template>
	<SplitterGroup :class="cn(props.class)" v-bind="forwarded">
		<SlotRenderer />
	</SplitterGroup>
</template>
